import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c450c46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Progress" }
const _hoisted_2 = {
  viewBox: "0 0 255 4",
  class: "Progress__Bar",
  preserveAspectRatio: "none"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "0",
  y1: "2",
  x2: "255",
  y2: "2"
}, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "Progress__Info"
}
const _hoisted_5 = {
  key: 1,
  class: "Progress__Info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("line", {
        class: "Progress__Current",
        x1: "0",
        y1: "2",
        x2: "255",
        y2: "2",
        style: _normalizeStyle(`stroke-dashoffset: ${255-255*_ctx.value/100};`)
      }, null, 4)
    ])),
    (this.type === 'percent')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(Math.floor(_ctx.value)) + "%", 1))
      : _createCommentVNode("", true),
    (this.type === 'score')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(Math.floor(_ctx.value)) + "/100", 1))
      : _createCommentVNode("", true)
  ]))
}